import UploadImg from "../../../Shared/Svgs/UploadImg";

const MyProfile = () => {
    return (
        <div className="MyProfile">
            <h3>My Profile</h3>

            <div className="myProfileContainer">
                <div className="myProfileImgContainer">
                    <div className="uploadImgFilter">
                        <UploadImg />
                    </div>
                    <img
                        src="/images/jane-doe.jpg"
                        className="profileImg"
                        alt="logo"
                    />
                </div>

                <div className="myProfileDetails">
                    <div className="profileInfo">
                        <div className="nameAndTitle">
                            <span>Jennifer Dobes</span>
                            <b>Project Manager</b>
                        </div>

                        <div className="verticalBar"></div>

                        <div className="contactDetails">
                            <span>
                                jane.doe@dentons.com
                            </span>
                            <span>+1 123-456-7891</span>
                        </div>
                    </div>
                    <div className="profileActions">
                        <span>Change Password</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;
